import { useContext } from "react";
import { Icon } from "@iconify/react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TextsContext } from "../context/textsContext";
import StyleFooter from "../scss/footer.module.scss";

// `variant="inline"` (default) is the compact badge used in the wizard footer
// (steps 1-7): icon + label with a tooltip, and a small text-link retry.
// `variant="card"` is the richer alert card used on Summary/Apply, where the
// price is the whole point of the screen and the warning needs more weight.
export const CalculationErrorBadge = ({ onRetry, retrying = false, variant = "inline" }) => {
    const { texts } = useContext(TextsContext);

    if (variant === "card") {
        return (
            <div className={`Poppins ${StyleFooter.calculationErrorCard}`}>
                <div className={StyleFooter.calculationErrorCardHeader}>
                    <span className={StyleFooter.calculationErrorCardIcon}>!</span>
                    <div>
                        <p className={StyleFooter.calculationErrorCardTitle}>
                            {texts?.footer_calculation_error_label ?? 'Price not updated'}
                        </p>
                        <p className={StyleFooter.calculationErrorCardSubtitle}>
                            {texts?.footer_calculation_error_card_subtitle
                                ?? 'Update the quote to see the latest annual cost.'}
                        </p>
                    </div>
                </div>
                {onRetry && (
                    <button
                        type="button"
                        onClick={onRetry}
                        disabled={retrying}
                        className={StyleFooter.calculationErrorCardButton}
                    >
                        <Icon
                            icon="mdi:refresh"
                            className={retrying ? StyleFooter.spinning : ''}
                        />
                        {retrying
                            ? (texts?.footer_calculation_error_retrying ?? 'Updating...')
                            : (texts?.footer_calculation_error_retry ?? 'Update price')}
                    </button>
                )}
            </div>
        );
    }

    return (
        <span className={`Poppins ${StyleFooter.calculationErrorWrapper}`}>
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="calculation-error-tooltip" className="custom-tooltip">
                        {texts?.footer_calculation_error_tooltip
                            ?? "Something failed trying to update the price with your latest changes. Showing the last calculated estimate."}
                    </Tooltip>
                }
            >
                <span className={`Poppins ${StyleFooter.calculationError}`}>
                    <Icon icon="mdi:alert-circle-outline" className={StyleFooter.calculationErrorIcon} />
                    {texts?.footer_calculation_error_label ?? 'Price not updated'}
                </span>
            </OverlayTrigger>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    disabled={retrying}
                    className={`Poppins ${StyleFooter.calculationErrorRetry}`}
                >
                    <Icon
                        icon="mdi:refresh"
                        className={`${StyleFooter.calculationErrorRetryIcon} ${retrying ? StyleFooter.spinning : ''}`}
                    />
                    {retrying
                        ? (texts?.footer_calculation_error_retrying ?? 'Updating...')
                        : (texts?.footer_calculation_error_retry ?? 'Update price')}
                </button>
            )}
        </span>
    );
};
